import { COLORS, DIM } from './configs/config'
import { View } from './components/view'
import { BackIcon } from './components/shared/back-icon'
import { HomePage } from './components/pages/home/home-page'
import { Base } from './base/components/base'
import router from './base/lib/router'
import { LoginPage } from './components/pages/login/login-page'
import { Notification } from './notification'
import { CashbackPage } from './components/pages/cashback/cashback-page'
import { MenuPage } from './components/pages/menu/menu-page'
import authService from './services/auth-service'
import {emitter} from './base/utils/emitter'

const view = View()
const app = Base('div')
const backIcon = BackIcon()
const notification = Notification()
app.append(backIcon, view, notification)

app.cssClass({
    margin: '0 auto',
    transition: 'all .16s',
    overflow: 'hidden',
    position: 'relative',
    [`@media (max-width: ${DIM.MOBILE}px)`]: {
        margin: '0 auto',
    }
})

const routes = {
    '/': HomePage,
    '/login': LoginPage,
    '/menu': MenuPage,
    '/cashback': CashbackPage,
    // '/fastpay': FastpayPage,
    // '/booking': BookingPage,
    // '/withdraw': WithdrawPage,
    // '/user': UserPage,
}

router.init({ routes, view, root: '/admin'/* , home: ldb.get('DANESH_FX_ADMIN_TOKEN') ? '/' : '/login' */ })

authService.checkToken().then(results => {
    if (results.errors) {
        // setState({ user: null })
        router.goto('/')
        emitter.emit('logged-out')
    }
})
export default app
